module.exports = __webpack_public_path__ + "img/house_icon.24d6ebbe.png";